import { connect } from 'react-redux';
import ContainerDetailDialog from './container-detail-dialog.presentation';
import {
  setContainerDetailTabIndex,
  downloadReeferDataDetailsAsync,
  setUIError,
  downloadFeederServiceOrderDetailAsync,
  showErrorSnackbar,
} from '../../redux/action';
import { RXSTATE_CONTAINER_TRACKING_DIALOG } from '../../constant';
import LocalizedString from '../../localization';
import { unauthorizedErrorHandler } from '../../helper';

const getContainerInfo = state => state
  .containerTrackingDetail[state.uiContainerTracking.tappedItemNo] || {};

const isFeederServiceAvailable = (state) => {
  const { tappedItemNo } = state.uiContainerTracking;
  const { feederServiceOrderDetail } = state;
  const container = feederServiceOrderDetail[tappedItemNo];
  const { downloading } = state.uiFeederServiceDetail;
  return !!container && !downloading;
};

const mapStateToProps = state => ({
  selectedTab: state.uiContainerTrackingDialog.tappedTabIndex,
  downloadingReeferData: state.uiReeferDataContainer.downloadingReeferDataDetails,
  containerInfo: state.containerTracking[state.uiContainerTracking.tappedBlNo],
  containerTrackingInfo: getContainerInfo(state),
  isFeederServiceAvailable: isFeederServiceAvailable(state),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  onAppear: (blNo, containerNo) => {
    try {
      dispatch(downloadReeferDataDetailsAsync(blNo, containerNo));
      dispatch(downloadFeederServiceOrderDetailAsync(blNo));
    } catch (error) {
      dispatch(showErrorSnackbar(LocalizedString.common.alertTitleError, error.message));
      unauthorizedErrorHandler(error, ownProps.history.push);
    }
  },
  onTabPressed: (tappedTabIndex) => {
    dispatch(setContainerDetailTabIndex(tappedTabIndex));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ContainerDetailDialog);
